import * as ngCore from '@angular/core'

/** Renders the icon pair used for boolean values in table cells. */
@ngCore.Component({
  selector: 'atn-value-boolean',
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /** Boolean value that determines which icon is displayed. */
  public readonly valueSg = ngCore.input<boolean | undefined>(undefined, {
    alias: 'value',
  })
}
